import type { NextPage } from 'next'
import Head from 'next/head'

import Activities from '@/components/activities'

const ActivitiesPage: NextPage = () => {
  return (
    <>
      <Head>
        <title>{'Inherit Wallet - History'}</title>
      </Head>

      <main>
        <Activities />
      </main>
    </>
  )
}

export default ActivitiesPage
